<div id="streetview" class="h-100 w-100">
  <div *ngIf="noData && !firstRender" class="h-100 w-100" style="background-color:lightgrey">
    <h3 class="text-center error-text"> {{ 'map.google_streetview_component.off_road' | translate }}</h3>
  </div>
  <div *ngIf="noData && firstRender" class="h-100 w-100" style="background-color:lightgrey">
    <h3 class="text-center error-text"> {{ 'map.google_streetview_component.tool_information' | translate }}</h3>
  </div>
</div>


